import {observable, computed, action} from 'mobx';
import autoBind from 'react-autobind';
import { useStrict } from 'mobx';

import history from '../sys/history.js'

useStrict(true);

function uniq(arr) {
  var obj = {};
  for (var i = 0; i < arr.length; i++) {
    var str = arr[i];
    obj[str] = true;
  }
  return Object.keys(obj);
}

class Store {
  host;
  @observable auth;
  @observable _orders;
  @observable isRefresh;
  refresh;
  @observable isBackButton;
  @observable backFunction;
  @observable options;
  @observable showErrors;
  @observable isDataLoaded;
  @observable lb;
  @observable dialog;
  turs = [];
  hotels = [];
  links = [];
  turCities = [];
  hotelCities = [];
  tursID = {};
  hotelsID = {};
  turGroups = [];
  hotelGroups = [];
  transfers = ['не нужен','групповой','индивидуальный'];
  cities = [];

 constructor(){
    autoBind(this);
    if ( process.env.NODE_ENV === 'development' ) {
      this.host = 'http://localhost';
    } else this.host = 'http://81.4.255.72';

    this.auth = 
      {
        loged: false,
        agentName: '',
        session: ''
      };
    this._orders = [];
    this.isRefresh = false;
    this.refresh = () => {};
    this.isBackButton = false;
    this.backFunction = () => {};
    this.initOptions();
    this.showErrors = false;
    this.isDataLoaded = false;
    this.lb = {isOpen: false, imgUrl: ''}
    this.dialog = 
      {
        okButton: 'OK',
        cancelButton: 'Отмена',
        title: '',
        message: '',
        open: false,
        buttons: false
      }
  }

// Начало confirm
  dialogOk

  dialogCancel

  @action confirm(params) {
    if (typeof params === 'string') params = {message: params};
    if (!params) params = {};
    this.dialog.message = params.message ? params.message : 'Вы уверены?';
    this.dialog.title = params.title ? params.title : 'Внимание!';
    this.dialog.okButton = params.ok ? params.ok : 'OK';
    this.dialog.cancelButton = params.cancel ? params.cancel : 'Отмена';
    this.dialog.buttons = true;
    this.dialog.open = true;
    var that = this;

    var promise = new Promise(function(resolve, reject) {
  
      // Эта функция будет вызвана автоматически
      // В ней можно делать любые асинхронные операции,
      // А когда они завершатся — нужно вызвать одно из:
      // resolve(результат) при успешном выполнении
      // reject(ошибка) при ошибке

      var onOk, onCancel;

      onOk = function() {
        resolve();
      }

      onCancel = function() {
        reject();
      }

      that.dialogOk = onOk;
      that.dialogCancel = onCancel;

    });
    return promise;
  }
// Конец confirm

  @action message(params) {
    this.dialog.buttons = false;
    this.dialog.message = params.message;
    this.dialog.title = params.title;
    this.dialog.open = true;
  }

  @action showLightBox(imgUrl) {
    this.lb.isOpen = true;
    this.lb.imgUrl = imgUrl;
  }

  @action hideLightBox() {
    this.lb.isOpen = false;
    this.lb.imgUrl = '';
  }

  @action setErrors(bool) {
    this.showErrors = bool;
  }

  @action clearRefresh() {
    this.isRefresh = false;
    this.refresh = () => {};
  }

  @action setRefresh(func) {
    this.isRefresh = true;
    this.refresh = func;
  }

  replacePage(newPage) {
    this.clearRefresh();
    window.scrollTo(0,0);
    history.replace(newPage);
    console.log('replace на страницу: ' + newPage);
    
  }

  pushPage(newPage) {
    this.clearRefresh();
    window.scrollTo(0,0);
    history.push(newPage);
    console.log('push на страницу: ' + newPage);
    
  }

  @action setOrders(array) {
    this._orders.replace( array );
  }

  @computed get orders() {
    return this._orders.slice();
  }

  @action setBackFunction(func) {
    this.isBackButton = true;
    this.backFunction = func;
  }

  @action clearBackFunction() {
    this.isBackButton = false;
    this.backFunction = () => {};
  }

  @action initOptions() {
    this.options = {
      transfer: 0,
      bilet: false,
      manag: '',
      telef: '',
      tur: {},
      hotel: {},
      city: -1,
      food: false,
      summa: 0,
      prim: '',
      tourists: [
        ]
      }
    this.addTourist();
    this.options.manag = localStorage.getItem('manag') ? localStorage.getItem('manag') : '';
    this.options.telef = localStorage.getItem('telef') ? localStorage.getItem('telef') : '';
    }

  @action addTourist() {
    this.options.tourists.push({fio: '', birthdate: '', passport: '', tel: ''});
  }

  @action removeTourist() {
    this.options.tourists.pop();
  }

  @action changeOption(name, value) {
    this.options[name] = value;
  }

  @action trimOptions() {
    const opt = this.options;
    const trs = this.options.tourists;
    for (var key in opt) {
      if (typeof opt[key] === 'string') opt[key] = opt[key].trim(); 
    }
    for (var i = 0; i < trs.length; i++) {
      trs[i].fio = trs[i].fio.trim();
      trs[i].passport = trs[i].passport.trim();
    }
  }

  @action setDataLoaded(value) { this.isDataLoaded = value }

  @action loadData(data) {
    this.turs = data.turs; 
    this.turs.sort((a,b) => {if (a.name > b.name) {return 1} else return -1}); 
    this.hotels = data.hotels;
    this.hotels.sort((a,b) => {if (a.name > b.name) {return 1} else return -1}); 
    //console.log('sorted hotels: ', this.hotels);
    this.links = data.links;
    this.turCities = uniq(this.turs.map( (row, index) => row.city ));
    this.hotelCities = uniq(this.hotels.map( (row, index) => row.city ));
    this.tursID = {};
    this.hotelsID = {};
    var i;
    var obj = {};
    for (i = 0; i < this.turs.length; i++) {
      this.tursID[this.turs[i].id] = this.turs[i];
      obj[this.turs[i].turgroup] = true;
    }
    this.turGroups = Object.keys(obj);
    obj = {}
    for (i = 0; i < this.hotels.length; i++) {
      this.hotelsID[this.hotels[i].id] = this.hotels[i];
      obj[this.hotels[i].hotelgroup] = true;
    }
    this.hotelGroups = Object.keys(obj);
    this.cities = data.cities.split('<br>');
    console.log('cities ', this.cities);
  }

  @action setTur(obj) { this.options.tur = obj };
  
  @action setHotel(obj) { this.options.hotel = obj };

  getHotelGroupsForTur(idtur) {
    var turlinks = this.links.filter( (item)=>{ return ( item.idtur === idtur ) });
    var obj = {};
    for (var i = 0; i < turlinks.length; i++) {
      var str = this.hotelsID[turlinks[i].idotel].hotelgroup;
      obj[str] = true;
    }
    return Object.keys(obj);
  }

  getHotelsForTur(idtur) {
    var hotels = [];
    var links = this.links;
    for (var i = 0; i < links.length; i++) {
      if (links[i].idtur === idtur) {
        hotels.push({link: links[i], hotel: this.hotelsID[links[i].idotel] })
      }
    }
    hotels.sort((a,b) => {if (a.hotel.name > b.hotel.name) {return 1} else return -1})
    return hotels;
  }

  getTursForHotel(idhotel) {
    var turs = [];
    var links = this.links;
    for (var i = 0; i < links.length; i++) {
      if (links[i].idotel === idhotel) {
        turs.push({link: links[i], tur: this.tursID[links[i].idtur] })
      }
    }
    turs.sort((a,b) => {if (a.tur.name > b.tur.name) {return 1} else return -1})
    return turs;
  }

}

var store = new Store();
export default store;


// WEBPACK FOOTER //
// ./src/store/store.js